import React, { Fragment, useCallback } from 'react';
import classnames from 'classnames';
import { List } from 'react-admin';
import { Route, useHistory } from 'react-router-dom';
import { Drawer, useMediaQuery, makeStyles } from '@material-ui/core';

import ContractListMobile from './ContractListMobile';
import ContractListDesktop from './ContractListDesktop';
import ContractFilter from './ContractFilter';
import ContractEdit from './ContractEdit';


const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    list: {
        flexGrow: 1,
        transition: theme.transitions.create(['all'], {
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginRight: 0,
    },
    listWithDrawer: {
        // marginRight: 400,
    },
    drawerPaper: {
        zIndex: 100,
    },
}));

const ContractList = ({ permissions, ...props }) => {
    const classes = useStyles();
    const isXSmall = useMediaQuery(theme => theme.breakpoints.down('xs'));
    const history = useHistory();

    const handleClose = useCallback(() => {
        history.push('/contracts');
    }, [history]);

    return (
        <div className={classes.root}>
            <Route path="/contracts/:id">
                {({ match }) => {
                    const isMatch = !!(
                        match &&
                        match.params &&
                        match.params.id !== 'create'
                    );

                    if (permissions) return (
                        <Fragment>
                            <List
                                {...props}
                                className={classnames(classes.list, {
                                    [classes.listWithDrawer]: isMatch,
                                })}
                                bulkActionButtons={false}
                                filters={<ContractFilter />}
                                filter={
                                    permissions.role.type === 'supplier' ?
                                    { 'supplier': permissions.supplier._id } :
                                        permissions.role.type === 'validator' ?
                                        { 'budget.user': permissions._id } :
                                            {}
                                }
                                perPage={25}
                                sort={{ field: 'createdAt', order: 'DESC' }}
                            >
                                {isXSmall ? (
                                    <ContractListMobile />
                                ) : (
                                    <ContractListDesktop />
                                )}
                            </List>
                            <Drawer
                                variant="persistent"
                                open={isMatch}
                                anchor="right"
                                onClose={handleClose}
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                            >
                                {/* To avoid any errors if the route does not match, we don't render at all the component in this case */}
                                {isMatch ? (
                                    <ContractEdit
                                        id={match.params.id}
                                        onCancel={handleClose}
                                        {...props}
                                    />
                                ) : null}
                            </Drawer>
                        </Fragment>
                    );
                }}
            </Route>
        </div>
    );
};

export default ContractList;
